import React, { useState, useEffect } from 'react';

import { useStateValue } from '../hooks/useState';
import { useTranslation } from 'react-i18next';
import { Footer } from '../components/FooterNew/Footer';
import { useLocationPrepare } from '../hooks/useLocationPrepare';
import { QRComponent } from '../components/QRComponentNew/QRComponent';
import { SMS } from '../components/smsNew/SMS';
import { useRouter } from '../react-router-hooks';
import Skeleton from 'react-loading-skeleton';
import { MaintenanceScreen } from './MaintenanceScreen';
import { MaintenanceCoronaScreen } from './MaintenanceCoronaScreen';
import { useWideScreen } from '../hooks/useWide';
import { LanguageSelector } from '../components/languageSelector/languageSelector';
import { LanguageSelectorWrapper } from '../components/languageSelector/languageSelector.styled';
import { supportedLanguages } from '../helper/supportedLangs';
import { MaintenanceLoadScreen } from './MaintenanceLoadScreen';
import { useDeliveryStatus } from '../hooks/useDeliveryStatus';
import { StateBox } from '../components/StateBoxNew/StateBox';
import { useKonamiCode } from '../hooks/useKonamiCode';

export const QRScreen = () => {
  useLocationPrepare();
  const { t } = useTranslation();
  const isKonamiCodeActive = useKonamiCode();

  const [
    {
      uuid,
      responseURI,
      caseStatus,
      coBranding,
      eIDMode,
      maintenance,
      deliveryPreview
    }
  ]: any = useStateValue();
  const { deliveryStatus, caseStatus: deliveryCaseStatus } = useDeliveryStatus({
    deliveryID: deliveryPreview?.deliveryID
  });
  const [title, setTitle] = useState('Identification is in progress...');
  const [subtitle, setSubtitle] = useState(
    'Finish the steps on the Nect Wallet to complete your verification. After the process was complete, you can retrieve your delivery.'
  );
  const isWideScreen = useWideScreen();

  const isLoaded = !!uuid || !!deliveryPreview;
  const isBox = !!deliveryPreview?.deliveryID;

  const [url, setUrl] = useState('');
  const [spLogo, setSpLogo] = useState('');

  const { location } = useRouter();

  useEffect(() => {
    if (uuid) {
      let endpoint = 'https://nect.com/app/?uuid=' + uuid;

      if (responseURI) {
        endpoint += '&responseURI=' + responseURI;
      }

      setUrl(endpoint);
    }
  }, [uuid, responseURI]);

  useEffect(() => {
    if (coBranding?.logo_b64) {
      setSpLogo(coBranding.logo_b64);
    }
  }, [coBranding]);

  useEffect(() => {
    if (deliveryCaseStatus) {
      if (
        deliveryCaseStatus.state === 'complete' &&
        !deliveryCaseStatus.canRetry &&
        deliveryCaseStatus.success === false
      ) {
        setTitle('Identification failed');
        setSubtitle(
          'Your identification has failed. This could have multiple reasons. Please get in touch with our partner {companyName} for further details.'
        );
      } else if (
        deliveryCaseStatus.state === 'complete' &&
        !deliveryCaseStatus.canRetry &&
        !['created', 'unbound'].includes(deliveryStatus?.status as string)
      ) {
        setTitle('Your identification is successful');
        setSubtitle(
          'You will now be able to retrieve your digital letter from the Nect Wallet. Don’t forget to accept the Terms for digital deliveries.'
        );
      }

      if (deliveryCaseStatus.reason === 'hold') {
        setTitle('On Hold');
        setSubtitle(
          'Please come back again later. Our expert is current unavailable. This may take until the next business day.'
        );
      } else if (
        deliveryCaseStatus.reason === 'cancel' ||
        deliveryCaseStatus.reason === 'timeout'
      ) {
        setTitle('Identification is complete');
        setSubtitle(
          'Please go back to our partner company and start a new identification'
        );
      } else if (
        deliveryCaseStatus.state === 'pending' ||
        (deliveryCaseStatus.state === 'created' &&
          deliveryCaseStatus.toSubmit.length) ||
        (deliveryCaseStatus.state === 'complete' &&
          deliveryCaseStatus.toSubmit.length &&
          deliveryCaseStatus.canRetry)
      ) {
        setTitle('Identification is in progress...');
        setSubtitle(
          'Finish the steps on the Nect Wallet to complete your verification. After the process was complete, you can retrieve your delivery.'
        );
      }
    }

    if (deliveryStatus?.status === 'retrieved') {
      setTitle('Delivery has been successful');
      setSubtitle(
        'You retrieved your digital letter with your Nect Wallet. You can access your letters any time there.'
      );
    }
  }, [deliveryCaseStatus, deliveryStatus, coBranding]);

  if (maintenance === 'LOAD') {
    return <MaintenanceLoadScreen />;
  } else if (maintenance === 'BANANA') {
    return <MaintenanceScreen />;
  } else if (maintenance === 'CORONA') {
    return <MaintenanceCoronaScreen />;
  }

  const showDefault =
    !deliveryCaseStatus && deliveryStatus?.status !== 'retrieved';
  const disableQRCodeForIdent = !deliveryPreview?.deliveryID && false; //!isKonamiCodeActive;

  return (
    <div className="newPageRoot">
      <LanguageSelectorWrapper>
        <LanguageSelector langs={supportedLanguages} />
      </LanguageSelectorWrapper>
      <div
        className="newPageWrapper"
        style={{
          justifyContent: isBox ? 'space-between' : 'center'
        }}
      >
        {isBox && (
          <div className="newPageEnvelopeWrapper">
            <img
              src={require('../assets/envelope.png')}
              alt="Envelope"
              style={{ objectFit: 'contain' }}
            />
            {!!spLogo && (
              <img
                src={spLogo}
                style={{
                  position: 'absolute',
                  height: '25px',
                  top: '110px',
                  right: '80px'
                }}
                alt="Service Provider"
              />
            )}
          </div>
        )}
        <div
          className="newPageWrapperInner"
          style={{
            textAlign: isBox ? 'left' : 'center',
            maxWidth: isBox ? 650 : 900
          }}
        >
          {/* {eIDMode && eIDMode !== '' && (
          <div
            className="newPageMessageBanner newPageMessageBanner-blue"
            style={{ marginBottom: 24 }}
            dangerouslySetInnerHTML={{
              __html: t(
                '<b>Today, the eID service will be updated.</b><br /> <br />This means that the online ID function of your ID card (eID) only works to a limited extent. We apologize for any inconvenience.'
              )
            }}
          />
        )} */}

          <div
            className="newPageHeaderLogos"
            style={{ justifyContent: isBox ? 'start' : 'center' }}
          >
            <img
              style={{ height: 50 }}
              src={require('../assets/nect-logo-black.svg')}
              alt="Nect"
            />
            {isWideScreen && spLogo && (
              <>
                <img
                  src={require('../assets/close-cross.png')}
                  style={{ height: 40, marginLeft: 16, marginRight: 16 }}
                  alt="Close"
                />
                <img
                  src={spLogo}
                  style={{ height: 50 }}
                  alt="Service Provider"
                />
              </>
            )}
          </div>

          {!showDefault && (
            <>
              <h1 className="newPageHeaderTitle">{t(title)}</h1>

              <p className="newPageHeaderSubtitle">
                {t(subtitle).replace(
                  '{companyName}',
                  coBranding?.jump_name || coBranding?.name || t('Nect')
                )}
              </p>

              <div style={{ display: 'inline-block', marginLeft: -24 }}>
                <StateBox caseStatus={deliveryCaseStatus} />
              </div>
            </>
          )}

          {showDefault && (
            <>
              <h1
                className="newPageHeaderTitle"
                style={{ textAlign: isBox ? 'left' : 'center' }}
              >
                {!isBox
                  ? t('Fast and simple online identification')
                  : t('You received a letter from {companyName}').replace(
                      '{companyName}',
                      coBranding?.name ? coBranding.name : t('Nect')
                    )}
              </h1>

              {isLoaded ? (
                <>
                  {!isBox && (
                    <p
                      className="newPageHeaderSubtitle"
                      dangerouslySetInnerHTML={{
                        __html:
                          coBranding && coBranding.name
                            ? t(
                                'Choose one of the following options to identify for <b>{companyName}</b>:'
                              ).replace('{companyName}', coBranding.name)
                            : t(
                                'Choose one of the following options to identify:'
                              )
                      }}
                    />
                  )}
                  {isBox && (
                    <p
                      className="newPageHeaderSubtitle"
                      dangerouslySetInnerHTML={{
                        __html: t(
                          'In order to open your letter you need to identify as {userName}. For that we use the Nect Wallet App.'
                        ).replace(
                          '{userName}',
                          `${deliveryPreview?.poi_given_name} ${deliveryPreview?.poi_last_name_short}`
                        )
                      }}
                    />
                  )}
                </>
              ) : (
                <Skeleton width={500} height={64} />
              )}

              <div
                className={`newPageCaseStartWrapper ${
                  disableQRCodeForIdent ? 'smsOnlyWrapper' : ''
                }`}
              >
                {!disableQRCodeForIdent && (
                  <div className="newPageCaseStartQR">
                    <div className="newPageCaseStartQRTitle">
                      <img
                        style={{ height: 80 }}
                        src={require('../assets/newJumpPage/scan.svg')}
                        alt="Scan"
                      />
                      <p>{t('Open your camera app and scan to start.')}</p>
                    </div>

                    {isLoaded ? (
                      <QRComponent />
                    ) : (
                      <Skeleton width={220} height={220} />
                    )}
                  </div>
                )}
                {!deliveryPreview?.deliveryID && (
                  <>
                    {!disableQRCodeForIdent && (
                      <div className="newPageCaseStartLine">
                        <div className="newPageCaseStartLineVL">
                          <div className="newPageCaseStartLabel">{t('OR')}</div>
                        </div>
                      </div>
                    )}
                    <div className="newPageCaseStartSMS">
                      <div className="newPageCaseStartSMSTitle">
                        <img
                          style={{ height: 80 }}
                          src={require('../assets/newJumpPage/sms.svg')}
                          alt="SMS"
                        />
                        <p>
                          {t(
                            'Send yourself a link to start the identification process.'
                          )}
                        </p>
                      </div>

                      {isLoaded ? (
                        <SMS />
                      ) : (
                        <>
                          <Skeleton width={280} height={180} />
                          <br />
                          <Skeleton width={280} height={40} />
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      <Footer
        isIFrame={location && location.state && location.state.isIFrame}
      />
    </div>
  );
};
